exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user[data-v-7cc3ea12]{background:#f7f7f7;padding-bottom:.2rem}.userCont[data-v-7cc3ea12]{height:1.36rem;padding-left:.2rem;padding-right:.44rem}.userPic[data-v-7cc3ea12]{width:.9rem;height:.9rem;border-radius:50%;border:1px solid #efefef;margin:0 .32rem}.list[data-v-7cc3ea12]{padding:0 .2rem}.item[data-v-7cc3ea12]{height:.88rem;border-color:#e5e5e5}.tit[data-v-7cc3ea12]{margin-right:.44rem;width:1.36rem}.btns[data-v-7cc3ea12]{position:fixed;bottom:.2rem;padding:0 .2rem;width:100%;box-sizing:border-box}.btn[data-v-7cc3ea12]{height:.9rem;line-height:.9rem;border-radius:.04rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cc3ea12","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/my/personalInfo/personalInfo.vue
// module id = 329
// module chunks = 0